const STEPS = [
  {
    code: "01",
    title: "See if your area actually stacks up",
    body:
      "Send us a property or area you're considering. We break down the data, maths, and investment logic behind it — no emotion, no guesswork.",
    detail: "Same day",
  },
  {
    code: "02",
    title: "We test it against real market data",
    body:
      "We analyse growth, demand, rental strength, and local fundamentals to see if it actually makes sense.",
    detail: "Same day",
  },
  {
    code: "03",
    title: "We break down the numbers",
    body:
      "Cash flow, costs, risks, and long-term growth potential. If it doesn't stack up, we say so clearly.",
    detail: "Same day",
  },
  {
    code: "04",
    title: "You decide the next move",
    body:
      "Buy, hold, improve, or walk away — with clear guidance on each option.",
    detail: "Your pace",
  },
  {
    code: "05",
    title: "Ongoing updates (optional)",
    body:
      "If you'd like, we'll keep you in the loop with simple, easy-to-understand updates — like having someone in your corner, helping you stay connected to how your investment is tracking and what's happening in the market.",
    detail: "Always on",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative py-24 sm:py-32 lg:py-40 bg-ink-surface border-y border-white/5"
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-12 lg:px-16">
        <div className="mb-12 lg:mb-16">
          <div className="data-label mb-6">/ How It Works</div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight max-w-3xl">
            Five steps. <span className="italic text-white/60">Nothing complicated.</span>
          </h2>
        </div>

        {/* Same-day promise banner */}
        <div
          data-testid="same-day-banner"
          className="mb-16 sm:mb-20 inline-flex items-center gap-4 border border-gold/40 bg-gold/5 px-5 py-3"
        >
          <span className="h-2 w-2 bg-gold rounded-full animate-pulse" />
          <span className="font-mono text-[11px] sm:text-xs tracking-[0.3em] uppercase text-gold">
            Done same day — not days later
          </span>
        </div>

        <div className="relative">
          <div className="absolute left-0 sm:left-32 top-0 bottom-0 w-px bg-white/10" />
          <div className="space-y-16 sm:space-y-20">
            {STEPS.map((s) => (
              <div
                key={s.code}
                data-testid={`process-step-${s.code}`}
                className="relative grid grid-cols-1 sm:grid-cols-12 gap-6 sm:gap-10 items-start"
              >
                <div className="sm:col-span-2 flex items-center gap-4">
                  <span className="font-mono text-[11px] tracking-[0.3em] text-gold">{s.code}</span>
                  <span className="h-px w-10 bg-gold/40" />
                </div>
                <div className="sm:col-span-6">
                  <h3 className="font-display text-3xl sm:text-4xl mb-3 leading-tight">{s.title}</h3>
                  <p className="text-white/65 leading-relaxed text-[15px] max-w-xl">{s.body}</p>
                </div>
                <div className="sm:col-span-3 sm:col-start-10 flex items-center gap-2 font-mono text-[11px] tracking-[0.25em] text-white/50 uppercase">
                  {s.detail === "Same day" && (
                    <span className="text-gold" aria-hidden>⏱</span>
                  )}
                  {s.detail === "Your pace" && (
                    <span className="text-gold" aria-hidden>◌</span>
                  )}
                  {s.detail === "Always on" && (
                    <span className="text-gold" aria-hidden>◉</span>
                  )}
                  <span>{s.detail}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
